// SPV Pool v1.0 PR 9 — Capital Markets entity-type scoping for the
// Watchlist and Recently Viewed dashboard widgets. The entity-type strings
// match the `RecordView` action-filter labels wired on the SPV / Pool /
// Investor / service-provider detail GETs (PR 1, PR 5).

export const CAPITAL_MARKETS_ENTITY_TYPES = [
  "SpvPool",
  "Spv",
  "Investor",
  "IndentureTrustee",
  "TrustCompany",
  "PlacementAgent",
  "BackupServicer",
] as const;

export type CapitalMarketsEntityType =
  (typeof CAPITAL_MARKETS_ENTITY_TYPES)[number];

const ENTITY_TYPE_SET = new Set<string>(CAPITAL_MARKETS_ENTITY_TYPES);

/** True when the entity type belongs to the Capital Markets module. */
export function isCapitalMarketsEntity(entityType: string): boolean {
  return ENTITY_TYPE_SET.has(entityType);
}

const ROUTE_MAP: Record<string, (id: string) => string> = {
  SpvPool: (id) => `/capital-markets/pools/${id}`,
  Spv: (id) => `/capital-markets/trusts/${id}`,
  Investor: (id) => `/capital-markets/investors/${id}`,
  IndentureTrustee: (id) => `/capital-markets/indenture-trustees/${id}`,
  TrustCompany: (id) => `/capital-markets/trust-companies/${id}`,
  PlacementAgent: (id) => `/capital-markets/placement-agents/${id}`,
  BackupServicer: (id) => `/capital-markets/backup-servicers/${id}`,
};

/** Resolve a Capital Markets entity to its detail-page route. */
export function resolveCapitalMarketsRoute(
  entityType: string,
  entityId: string,
): string {
  const resolver = ROUTE_MAP[entityType];
  return resolver ? resolver(entityId) : `/capital-markets/pools/${entityId}`;
}

const LABEL_MAP: Record<string, string> = {
  SpvPool: "Pools",
  Spv: "Trusts",
  Investor: "Investors",
  IndentureTrustee: "Indenture Trustees",
  TrustCompany: "Trust Companies",
  PlacementAgent: "Placement Agents",
  BackupServicer: "Backup Servicers",
};

/** Human-friendly group label for an entity type. */
export function entityTypeLabel(entityType: string): string {
  return LABEL_MAP[entityType] ?? entityType;
}
